module.exports = __webpack_public_path__ + "img/Synelva.f837c4a0.png";